module.exports = __webpack_public_path__ + "9be5eda42b29a1a82c83b5bd8d655164.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/png/circle-104@2x.png
// module id = 491
// module chunks = 0